import { Button, Link } from "@components/core";
import { useTranslations } from "next-intl";

function ClosetActionRTC() {
  const t = useTranslations("closets");

  return (
    <div>
      <p className="pt-2">{t("state.ready_to_change.closet_action_text")}</p>
      <Link href="/catalogue" className="py-3">
        <Button className="mx-auto">
          {t("state.ready_to_change.closet_action_button_title")}
        </Button>
      </Link>
    </div>
  );
};

export default ClosetActionRTC;
